import { LOCALE_BY_LANGUAGE } from '../../components/format-money';
import type { SupportedLanguage } from '../../i18n';

/**
 * A contract decimal string written in the UI language, digit for digit: "0.5" → "0,5" in
 * French. No `Number` conversion, so nothing is rounded.
 */
export function formatWireDecimal(wire: string, language: SupportedLanguage): string {
  return language === 'fr' ? wire.replace('.', ',') : wire;
}

const percentFormats = new Map<SupportedLanguage, Intl.NumberFormat>();

/**
 * Basis points as a percentage in the UI language: 500 → "5 %" (fr) / "5%" (en). Display only.
 * Home has the same formatter (`formatBps`, M1); sharing one is a follow-up for C3's
 * `format-money` (M2 explanation §6), since a feature never imports another one's internals.
 */
export function formatBpsPercent(bps: number, language: SupportedLanguage): string {
  let format = percentFormats.get(language);
  if (format === undefined) {
    format = new Intl.NumberFormat(LOCALE_BY_LANGUAGE[language], {
      style: 'percent',
      maximumFractionDigits: 2,
    });
    percentFormats.set(language, format);
  }
  return format.format(bps / 10_000);
}
